import React, { ChangeEvent, useState } from 'react';
import { Box } from 'lmc-ui-library';
import { TextArea } from 'form/components';
import { Nullable } from 'utils/types';
import { Loader } from 'form/components/Select/Select.styled';

interface Props {
  comment: Nullable<string>;
  onChange: (comment: string) => void;
  isSaving: boolean;
  disabled: boolean;
}

const GeneralComments: React.FC<Props> = ({ comment, onChange, isSaving, disabled }) => {
  const [value, setValue] = useState(comment);

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setValue(event.target.value);
  };

  const handleBlur = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(value || '');
  };

  return (
    <div>
      <Box style={{ marginBottom: '30px' }}>
        <Box.Content style={{ padding: '20px' }}>
          <label style={{ fontWeight: 'bold', fontSize: '14px', display: 'flex', alignItems: 'center' }}>
            General comments
            {isSaving && (
              <Loader style={{ display: 'inline-block', width: '16px', height: '16px', marginLeft: '10px' }} />
            )}
          </label>
          <div style={{ marginTop: '10px' }}>
            <TextArea rows={5} onChange={handleChange} onBlur={handleBlur} value={value || ''} disabled={disabled} />
          </div>
        </Box.Content>
      </Box>
    </div>
  );
};

export default GeneralComments;
